module.exports = __webpack_public_path__ + "img/start_tutorial.1dc59681.png";